import * as React from 'react'

const SvgCalenderIcon = ({ stroke }) => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 9.80005H1M14 1.80005V5.80005M6 1.80005V5.80005M5.8 21.8H14.2C15.8802 21.8 16.7202 21.8 17.362 21.4731C17.9265 21.1854 18.3854 20.7265 18.673 20.162C19 19.5203 19 18.6802 19 17V8.60005C19 6.91989 19 6.07981 18.673 5.43808C18.3854 4.87359 17.9265 4.41465 17.362 4.12703C16.7202 3.80005 15.8802 3.80005 14.2 3.80005H5.8C4.11984 3.80005 3.27976 3.80005 2.63803 4.12703C2.07354 4.41465 1.6146 4.87359 1.32698 5.43808C1 6.07981 1 6.91989 1 8.60005V17C1 18.6802 1 19.5203 1.32698 20.162C1.6146 20.7265 2.07354 21.1854 2.63803 21.4731C3.27976 21.8 4.11984 21.8 5.8 21.8Z"
      stroke={stroke || '#A4BCFD'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgCalenderIcon
